<template #default>
    <div>
        <h6 class="font-weight-bold text-info mb-3">
            <i class="mdi mdi-information-outline mr-1"></i>Basic Information
        </h6>
        <div class="row">
            <div class="col-md-6 mb-3">
                <small class="text-muted d-block mb-1">UUID</small>
                <div class="border rounded bg-light p-2 text-break">{{ servedeckLog.uuid ?? '--' }}</div>
            </div>
            <div class="col-md-6 mb-3">
                <small class="text-muted d-block mb-1">Method</small>
                <div class="border rounded bg-light p-2 text-break">{{ servedeckLog.method ?? '--' }}</div>
            </div>
            <div class="col-md-6 mb-3">
                <small class="text-muted d-block mb-1">Action</small>
                <div class="border rounded bg-light p-2 text-break">{{ servedeckLog.action ?? '--' }}</div>
            </div>
            <div class="col-md-6 mb-3">
                <small class="text-muted d-block mb-1">Status Code</small>
                <div class="border rounded bg-light p-2 text-break">{{ servedeckLog.statusCode ?? '--' }}</div>
            </div>
            <div class="col-md-6 mb-3">
                <small class="text-muted d-block mb-1">Duration (ms)</small>
                <div class="border rounded bg-light p-2 text-break">{{ servedeckLog.durationMs ?? '--' }}</div>
            </div>
            <div class="col-md-6 mb-3">
                <small class="text-muted d-block mb-1">Created At</small>
                <div class="border rounded bg-light p-2 text-break">{{ servedeckLog.createdAt ?? '--' }}</div>
            </div>
            <div class="col-md-6 mb-3">
                <small class="text-muted d-block mb-1">Updated At</small>
                <div class="border rounded bg-light p-2 text-break">{{ servedeckLog.updatedAt ?? '--' }}</div>
            </div>
            <div class="col-md-6 mb-3">
                <small class="text-muted d-block mb-1">Success</small>
                <b-badge :variant="servedeckLog.success ? 'success' : 'secondary'">{{ servedeckLog.success ? $t('label.yes') : $t('label.no') }}</b-badge>
            </div>
        </div>
        <hr>
        <div class="mb-3">
            <h6 class="font-weight-bold text-info mb-3"><i class="mdi mdi-web mr-1"></i>URL</h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                <div class="text-break" style="white-space: pre-line;">{{ servedeckLog.url || '--' }}</div>
            </div>
        </div>
        <hr>
        <div class="mb-3">
            <h6 class="font-weight-bold text-info mb-3"><i class="mdi mdi-alert-circle-outline mr-1"></i>Error Message</h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                <div class="text-break" style="white-space: pre-line;">{{ servedeckLog.errorMessage || '--' }}</div>
            </div>
        </div>
        <hr>
        <div class="mb-3">
            <h6 class="font-weight-bold text-info mb-3"><i class="mdi mdi-code-json mr-1"></i>Request Payload</h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                <pre class="mb-0">{{ servedeckLog.requestPayload != null ? getJsonText(servedeckLog.requestPayload) : '--' }}</pre>
            </div>
        </div>
        <hr>
        <div class="mb-3">
            <h6 class="font-weight-bold text-info mb-3"><i class="mdi mdi-code-json mr-1"></i>Response Payload</h6>
            <div class="border rounded bg-light p-3 overflow-auto">
                <pre class="mb-0">{{ servedeckLog.responsePayload != null ? getJsonText(servedeckLog.responsePayload) : '--' }}</pre>
            </div>
        </div>
        <hr class="my-3 mx-n4">
        <div class="d-flex justify-content-end">
            <b-button type="button" variant="danger" class="col-2" @click="$emit('done')">{{ $t('label.cancel') }}</b-button>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        servedeckLog: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getJsonText(data) {
            if (typeof data == 'string') {
                try {
                    return JSON.stringify(JSON.parse(data), null, 2);
                } catch (e) {
                    return data;
                }
            }
            return JSON.stringify(data, null, 2);
        },
    },
}
</script>
